import angular from 'angular';
import Navbar from './navbar/navbar';
import Authentication from './authentication/authentication';
import PageLoader from './pageLoader/pageLoader';
import UserAccountService from './userAccountService/userAccountService';
import AppHeader from './appHeader/appHeader';
import AppFooter from './appFooter/appFooter';
import Tiles from './tiles/tiles';
import ContentLoader from './contentLoader/contentLoader';
import HttpDim from './httpDim/httpDim';
import TableService from './tableService/tableService';
import EntitlerService from './entitlerService/entitlerService';
import FormValidation from './formValidation/formValidation';
import InfiniteScroll from './infiniteScroll/infiniteScroll';
import ModalLoader from './modalLoader/modalLoader';
import CustomerService from './customer/customer';
import Role from './role/role';
import IntTypeValidation from './intTypeValidation/intTypeValidation';
import Impersonation from './impersonation/impersonation';
import PasswordResetService from './passwordResetService/passwordResetService';
import AgentDownloadLinkService from './agentDownloadLinkService/agentDownloadLinkService';
import CustomerIntegrations from './customerIntegrations/customerIntegrations';
import Batch from './batch/batch';
import Extracts from './extracts/extracts';
import NavBarService from './navBarService/navBarService';
import OneRosterApi from './oneRosterApi/oneRosterApi';
import SourceFileService from './sourceFileService/sourceFileService';
import ErrorsLegend from './errorsLegend/errorsLegend';
import SourceErrors from './sourceErrors/sourceErrors';
import BannerMessage from './bannerMessage/bannerMessage';
import DataBrowserService from './dataBrowserService/dataBrowserService';
import Sso from './sso/sso';
import OrchestrationError from './orchestrationError/orchestrationError';
import multiselectModule from './multiselect/multiselect';
import LegendBar from './legendBar/legendBar';
import StringUtils from './stringUtils/stringUtils';


let commonModule = angular.module('app.common', [
  Navbar.name,
  Authentication.name,
  PageLoader.name,
  UserAccountService.name,
  AppHeader.name,
  AppFooter.name,
  Tiles.name,
  ContentLoader.name,
  HttpDim.name,
  TableService.name,
  EntitlerService.name,
  FormValidation.name,
  InfiniteScroll.name,
  ModalLoader.name,
  CustomerService.name,
  Role.name,
  IntTypeValidation.name,
  Impersonation.name,
  PasswordResetService.name,
  AgentDownloadLinkService.name,
  CustomerIntegrations.name,
  Batch.name,
  Extracts.name,
  NavBarService.name,
  OneRosterApi.name,
  SourceFileService.name,
  ErrorsLegend.name,
  SourceErrors.name,
  BannerMessage.name,
  DataBrowserService.name,
  Sso.name,
  OrchestrationError.name,
  multiselectModule.name,
  LegendBar.name,
  StringUtils.name
]);

export
default commonModule;



// WEBPACK FOOTER //
// ./app/common/common.js